var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cta',{staticClass:"link",attrs:{"type":_vm.currentComponent,"to":_vm.$trl(_vm.currentRoute),"colors":_vm.colors,"href":_vm.currentHref,"target":_vm.target}},[_vm._v(_vm._s(_vm.cta.caption))])}
var staticRenderFns = []

export { render, staticRenderFns }